import * as React from 'react';

import Rive from '@rive-app/react-canvas';

import {Checkbox} from 'shells/checkbox/checkbox';
import {TrialGatheringLayout} from 'shells/trial-gathering/trial-gathering-layout';

import {TinyIntroCompanyNameLogo} from '../../fields/tiny-intro-company-name-logo';
import {TinyIntroTextField} from '../../fields/tiny-intro-text-field';

import {ANIMATION_SRC, NUMBER_OF_STEPS} from '../consts';

import styles from '../gathering-page.module.css';

type Props = {
    onNext: () => void;
    fields: {
        companyName: string;
        setCompanyName: (companyName: string) => void;
        logoUrl: string | null | undefined;
        setLogoUrl: (logoUrl?: string | null | undefined) => void;
        website: string;
        setWebsite: (website: string) => void;
        workPhone: string;
        setWorkPhone: (workPhone: string) => void;
        textMessageOptIn: boolean;
        setTextMessageOptIn: (textMessageOptIn: boolean) => void;
    };
    handleStepViewed: () => void;
};

export function GetToKnow(props: Props) {
    const [companyNameError, setCompanyNameError] = React.useState<string | null | undefined>(null);

    React.useEffect(() => {
        props.handleStepViewed();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if (props.fields.companyName.trim().length > 0) {
            setCompanyNameError(null);
        }
    }, [props.fields.companyName]);

    const handleNext = () => {
        if (props.fields.companyName.trim().length === 0) {
            setCompanyNameError('Please enter a company name');
        } else {
            props.onNext();
        }
    };

    return (
        <TrialGatheringLayout
            prompt='Let’s get to know you better!'
            currentStep={1}
            totalSteps={NUMBER_OF_STEPS}
            animation={<Rive src={ANIMATION_SRC.GET_TO_KNOW} />}
            animationBackgroundColor='navyXltNew'
            onNext={handleNext}
        >
            <div className={styles['step-get-to-know-container']}>
                <TinyIntroCompanyNameLogo
                    variant='controlled'
                    title='Company name'
                    companyLogoUrl={props.fields.logoUrl}
                    onCompanyLogoUrlChange={props.fields.setLogoUrl}
                    companyName={props.fields.companyName}
                    onCompanyNameChange={props.fields.setCompanyName}
                    isRequired={true}
                    error={companyNameError}
                />
                <TinyIntroTextField
                    variant='controlled'
                    title='Website'
                    placeholder='www.example.com'
                    name='website'
                    value={props.fields.website}
                    onChange={props.fields.setWebsite}
                />
                <TinyIntroTextField
                    variant='controlled'
                    title='Phone number'
                    placeholder='I.e. 123 456-7890'
                    name='phone'
                    value={props.fields.workPhone}
                    onChange={props.fields.setWorkPhone}
                />
                <Checkbox
                    checked={props.fields.textMessageOptIn}
                    onChange={props.fields.setTextMessageOptIn}
                    label='The Nutshell team can send me personal text messages about this trial. Opt
                        out any time.'
                    isLarge={false}
                    isTopAligned={true}
                    labelColor='light'
                />
            </div>
        </TrialGatheringLayout>
    );
}
